import { render, staticRenderFns } from "./AnnuityRefundSchedule.vue?vue&type=template&id=5dfcd976&scoped=true"
import script from "./AnnuityRefundSchedule.vue?vue&type=script&lang=js"
export * from "./AnnuityRefundSchedule.vue?vue&type=script&lang=js"
import style0 from "./AnnuityRefundSchedule.vue?vue&type=style&index=0&id=5dfcd976&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dfcd976",
  null
  
)

export default component.exports